module.exports = __webpack_public_path__ + "static/media/S (57).7155e7fb.jpg";